import React from "react";
import { Reveal, Overline, Starburst } from "../common";
import { IMAGES } from "../../data/site";

const About = () => (
  <section id="about" className="py-24 md:py-32 bg-background scroll-mt-20" data-testid="about-section">
    <div className="max-w-[88rem] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-3xl shadow-xl aspect-[4/5]">
              <img
                src={IMAGES.residential2}
                alt="Clean, welcoming home interior in the Dallas–Fort Worth area"
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 bg-jet-teal text-white rounded-2xl px-7 py-5 shadow-xl teal-glow">
              <div className="font-display text-3xl font-semibold">100%</div>
              <div className="text-xs font-bold uppercase tracking-wider">
                Satisfaction<br />Focused
              </div>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <Overline className="mb-5">About Jet Cleaning Service</Overline>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-jet-ink">
            Built on reliability.
          </h2>
          <p className="mt-6 text-lg text-jet-ink/70 leading-relaxed">
            At Jet Cleaning Service, we believe exceptional cleaning starts with
            exceptional service. Our mission is to provide dependable,
            detail-focused cleaning backed by clear communication and a team you
            can trust. Whether we're preparing apartment homes for new residents,
            maintaining professional office spaces, or helping families enjoy a
            cleaner home, our goal is the same: deliver consistent results that
            exceed expectations.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-8 rounded-3xl border border-jet-teal/20 bg-jet-teal/5 p-8 md:p-10">
            <div className="flex items-center gap-2 mb-3">
              <Starburst className="h-4 w-4 text-jet-amber" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-jet-teal-deep">
                Our Mission
              </span>
            </div>
            <p className="font-display text-xl md:text-2xl font-medium text-jet-ink leading-snug">
              To make every property cleaner, healthier, and ready for the people
              who use it every day — building lasting relationships through
              dependable service, clear communication, and meticulous attention
              to detail.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
